import React from 'react';
import { Box, Typography } from '@mui/material';

const StudentImage = ({ studentData, t, API_BASE_URL, renderCheckboxes }) => {
  if (!studentData) {
    return <Typography>{t('review.no_work_for_display')}</Typography>;
  }
  return (
    <Box style={{ position: 'relative', width: '90%' }}>
      <img
        src={`${API_BASE_URL}/api/radovi/finalni_radovi/${studentData.class}/${studentData.image_url}`}
        //  src={`${API_BASE_URL}/api/povezani-radovi/${studentData.class}/${studentData.id}.jpg`}
        alt={t('review.studentExam')}
        style={{
          width: '100%',
          height: 'auto',
          position: 'relative',
          zIndex: 1,
          objectFit: 'contain'
        }}
      />
      <Box
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 2
        }}
      >
        {renderCheckboxes()}
      </Box>
    </Box>
  );
};

export default StudentImage;
